import { Route, Routes, useNavigate } from "react-router-dom";
import AdminDashboard from "./components/AdminDashboard";
import Home from "./pages/Home";
import { useEffect, useState } from "react";
import DeviceTable from "./components/DeviceTable";
import DeviceDetails from "./pages/DeviceDetails";
import { getToken } from "./services/apiServices";
import SignupModal from "./components/SignupModal";
import { useCbomContext } from "./context/CbomContext";
import Dashboard from "./pages/Dashboard";
import ProjectCreationForm from "./components/ProjectCreation";
import SensorAgent from "./components/SensorAgent";
import ViewSensorAgent from "./components/modals/ViewSensorAgent";
import OverallSummary from "components/OverallSummary";

function App() {
  const navigate = useNavigate();
  const [tokenReady, setTokenReady] = useState(false);
  const { isAuthenticated, setIsAuthenticated } = useCbomContext();
  useEffect(() => {
    const fetchToken = async () => {
      await getToken();
      setTokenReady(true);
    };
    fetchToken();
  }, []);
  useEffect(() => {
    const hasReloaded = sessionStorage.getItem("hasReloaded");
    if (!hasReloaded) {
      sessionStorage.setItem("hasReloaded", "true");
    } else {
      const token = localStorage.getItem("token");
      if (token) setIsAuthenticated(true);
      navigate("/");
    }
  }, []);
  if (!tokenReady) return <div>Loading...</div>;
  return (
    <>
      {!isAuthenticated ? (
        // Show just the login modal when not logged in
        <SignupModal />
      ) : (
        <Routes>
          {/* AdminDashboard as a layout */}
          <Route path="/" element={<AdminDashboard />}>
            <Route index element={<Dashboard />} />
            {/* Nested routes under AdminDashboard */}
            <Route path="ud" element={<Home />} />
            <Route
              path="projectcreationform"
              element={<ProjectCreationForm />}
            />
            <Route path="device" element={<DeviceTable />} />
            <Route path="cbomRecords" element={<DeviceDetails />} />
            <Route path="sensorAgent" element={<SensorAgent />} />
            <Route path="viewSensorAgent" element={<ViewSensorAgent />} />
            <Route path="overallsummary" element={<OverallSummary />} />
          </Route>
        </Routes>
      )}
    </>
  );
}

export default App;
